// API endpoints for the Home Matters application
// REACT_APP_API_URL can be provided either WITH or WITHOUT trailing /api.
// Normalize so API_BASE_URL never ends up like /api/api.
const RAW_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000').trim().replace(/\/+$/,'');
// If env already ends with /api (case-insensitive), use it directly; else append /api
export const API_BASE_URL = /\/api$/i.test(RAW_BASE) ? RAW_BASE : `${RAW_BASE}/api`;

export const COMMISSION_ENDPOINTS = {
  base: `${API_BASE_URL}/commissions`,
  LIST: `${API_BASE_URL}/commissions`,
  CREATE: `${API_BASE_URL}/commissions`,
  UPDATE: (id) => `${API_BASE_URL}/commissions/${id}`,
  DELETE: (id) => `${API_BASE_URL}/commissions/${id}`,
  GET_BY_ID: (id) => `${API_BASE_URL}/commissions/${id}`,
  // Matching endpoints
  MATCH_RECORDS: `${API_BASE_URL}/commissions/match-records`,
  MATCHING_STATS: `${API_BASE_URL}/commissions/matching-stats`,
  // Match results persistence endpoints
  MATCH_RESULTS: `${API_BASE_URL}/commissions/match-results`,
  MATCH_RESULTS_LATEST: `${API_BASE_URL}/commissions/match-results/latest`,
  MATCH_RESULTS_CHECK_REFRESH: `${API_BASE_URL}/commissions/match-results/check-refresh`,
  MATCHING_SESSION: `${API_BASE_URL}/commissions/matching-session`,
  MATCHING_SESSION_LATEST: `${API_BASE_URL}/commissions/matching-session/latest`,
  MATCHING_SESSIONS: `${API_BASE_URL}/commissions/matching-sessions`,
  // Commission tracking endpoints (Phase 4)
  COMMISSION_TRACKER_GENERATE: `${API_BASE_URL}/commissions/commission-tracker/generate`,
  COMMISSION_TRACKER: `${API_BASE_URL}/commissions/commission-tracker`,
  COMMISSION_TRACKER_UPDATE_STATUS: (id) => `${API_BASE_URL}/commissions/commission-tracker/${id}/status`,
  COMMISSION_SUMMARY: (month) => `${API_BASE_URL}/commissions/commission-tracker/monthly-summary/${month}`,
  REP_PERFORMANCE: `${API_BASE_URL}/commissions/commission-tracker/rep-performance`
};

// Default export for convenience
export default {
  API_BASE_URL,
  COMMISSION_ENDPOINTS,
};

